// extracted by mini-css-extract-plugin
export var lgBreak = "1200";
export var mdBreak = "992";
export var select = "Select-module--select--60481";
export var selectButton = "Select-module--selectButton--2ed86";
export var selectLabel = "Select-module--selectLabel--7cb23";
export var selectOption = "Select-module--selectOption--29856";
export var selectOption_highlighted = "Select-module--selectOption_highlighted--46a3a";
export var selectOption_selected = "Select-module--selectOption_selected--184a4";
export var selectOptions = "Select-module--selectOptions--453d0";
export var smBreak = "768";
export var variant__overdraftCalculator = "Select-module--variant__overdraftCalculator--0f622";
export var xsBreak = "480";